import debounce from "lodash/debounce";
import _ from "lodash";
import { action, decorate, observable } from "mobx";

class TypeaheadDropdownStore {
  suggestions = [];
  previousSelections = [];

  constructor(typeAheadApi, pitsMetadataStore, experienceStore) {
    this.typeAheadApi = typeAheadApi;
    this.pitsMetadataStore = pitsMetadataStore;
    this.experienceStore = experienceStore;
    this.fetchSuggestions = debounce(this.fetchSuggestions.bind(this), 200);
  }

  clearSuggestions() {
    this.suggestions = [];
  }

  clearPreviousSelections() {
    this.previousSelections = [];
  }

  _mapResponse(searchTerms) {
    const suggestions = searchTerms.map(s => {
      return {
        label: s["displayName"],
        value: String(s["name"])
      };
    });
    // Since each time that they search for a new value, it's a new list that,
    // most probably, it will not include the previous values; add it to the suggestions
    // so that it can be matched in the autocomplete
    if (this.previousSelections.length > 0) {
      this.suggestions = _.uniqBy(
        suggestions.concat(this.previousSelections),
        "value"
      );
    } else {
      this.suggestions = suggestions;
    }
  }

  _mapTags(players, teams, tags) {
    const playerTags = players.map(p => {
      const slug = `playerid-${p["playerId"]}`;
      return {
        label: `${p["displayName"]} (${slug})`,
        value: slug
      };
    });

    const teamTags = teams.map(t => {
      const slug = `teamid-${t["teamId"]}`;
      return {
        label: `${t["displayName"]} (${slug})`,
        value: slug
      };
    });

    const forgeTags = tags.map(t => {
      return {
        label: `${t["displayName"]} (${t["slug"]})`,
        value: t["slug"]
      };
    });

    const suggestions = playerTags.concat(teamTags).concat(forgeTags);

    // Since each time that they search for a new value, it's a new list that,
    // most probably, it will not include the previous values; add it to the suggestions
    // so that it can be matched in the autocomplete
    if (this.previousSelections.length > 0) {
      this.suggestions = _.uniqBy(
        suggestions.concat(this.previousSelections),
        "value"
      );
    } else {
      this.suggestions = suggestions;
    }
  }

  addPreviousSelections(selections) {
    if (selections.length > 0) {
      this.previousSelections = _.uniqBy(
        this.previousSelections.concat(selections),
        "value"
      );
      this.suggestions = _.uniqBy(this.suggestions.concat(selections), "value");
    }
  }

  resetPreviousSelections(selections) {
    this.previousSelections = selections;
  }

  fetchSuggestions(searchTerm, fieldId) {
    if (searchTerm && fieldId) {
      return this.typeAheadApi
        .getSuggestions(searchTerm, fieldId, this.experienceStore.searchType)
        .then(data => this._mapResponse(data["searchTerms"]));
    } else if (searchTerm) {
      return this.typeAheadApi.getAllSuggestions(searchTerm).then(data => {
        return data;
      });
    }
  }

  fetchTags(searchTerm) {
    if (searchTerm) {
      return this.typeAheadApi.getAllSuggestions(searchTerm).then(data => {
        this._mapTags(data["players"], data["teams"], data["tags"]);
      });
    }
  }
}

decorate(TypeaheadDropdownStore, {
  suggestions: observable,
  fetchSuggestions: action,
  fetchTags: action,
  clearSuggestions: action
});

export default TypeaheadDropdownStore;



// WEBPACK FOOTER //
// ./src/stores/TypeaheadDropdownStore.js